module.exports = "<home-carousel-view></home-carousel-view>\r\n\r\n<p class=\"blue-label\">Digital Innovation Hub dedicated to flexible electronics technologies</p>\r\n\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/home/home.component.html
// module id = ./Frontend/src/app/components/home/home.component.html
// module chunks = main